module.exports = __webpack_public_path__ + "img/applyRecords-active.cbe94012.svg";